import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data from "../../Data/accountingPolicy/accountingPolicyData.json";

export default function AccountingPolicy() {
  return (
    <section className="licenses antiCorruption development">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title development__title">
        Учетная политика
      </h1>

      <Accordion data={data} />
    </section>
  );
}
